import { useTranslation } from "react-i18next";
import { Clock } from "../icons";
import { formatBookingDate } from "../../../utils/countryLocaleMap";

interface PreorderOffersInfoProps {
  /** Collins' `customer_preorder_settings.close_date`, when pre-orders have a deadline. */
  readonly closeDate?: string;
  /** The venue's country, which sets the locale the date is written in. */
  readonly countryCode: string;
  /** The venue's timezone, in which a close-date timestamp is read. */
  readonly venueTimezone?: string;
}

/** The pre-order offers intro, followed by the pre-order close date when there is one. */
export function PreorderOffersInfo({ closeDate, countryCode, venueTimezone }: PreorderOffersInfoProps) {
  const { t } = useTranslation();
  const formattedCloseDate = formatBookingDate(closeDate, countryCode, "long", venueTimezone);

  return (
    <div className="pre-order-info">
      <p>{t("pre_order_offers_info", "Take advantage of our pre-order offers!")}</p>
      {formattedCloseDate && (
        <p className="gcw:flex gcw:items-center gcw:gap-2 gcw:mt-1">
          <Clock size={16} aria-hidden="true" className="gcw:shrink-0" />
          {t("bookings_close_on_date", "Pre-orders close on {{date}}.", { date: formattedCloseDate })}
        </p>
      )}
    </div>
  );
}
